import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import type { EIconType } from '@common/enums';

import { getSocialNetworkIconSrc } from './utils';

@Component({
    selector: 'web-social-networks',
    templateUrl: './web-social-networks.component.html',
    styleUrls: ['./web-social-networks.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, BsDropdownModule],
})
export class WebSocialNetworksComponent {
    @Input() public iconType: EIconType;
    @Input() public iconTypes: EIconType[] = [];
    @Input() public iconNames: any[] = [];

    @Output() public iconTypeChangeEvent = new EventEmitter<EIconType>();

    public getSocialNetworkIconSrc(type: string, socialName: string): string {
        return getSocialNetworkIconSrc(type, socialName);
    }

    public setIconType(iconType: EIconType): void {
        this.iconTypeChangeEvent.emit(iconType);
    }
}
